export default "__VITE_ASSET__DCXV88Js__"